import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';

export const SettingsImportsButtonContent: React.FC = () => (
    <PocIcon slot="prefix" name="more_vertical" style={{ margin: 0 }} />
);
